import Step1 from "./release-1.png";
import Step2 from "./release-2.png";

const releaseImg = [
  { id: "Step1", imageName: Step1, imageDesc: "Release Step 1" },
  { id: "Step2", imageName: Step2, imageDesc: "Release Step 2" },
];

export default releaseImg as HelpImage[];
